<button class="back-button" data-cy="back-button-section" (click)="goBack()">
  <ion-icon name="chevron-back" data-cy="exceptions-go-back-section-icon">
  </ion-icon>
  <span *ngIf="backButtonText" class="back-text" data-cy="back-text">
    {{ 'i18n.search.returnTo' | translate: { previousSection: '' } }} &nbsp;{{
      backButtonText | translate
    }}
  </span>
  <span *ngIf="!backButtonText" class="back-text" data-cy="back-text">
    {{ 'i18n.common.back' | translate }}
  </span>
</button>
